// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../config/styles';

const styles = ({
  label: {
    color: GlobalStyles.color.COLOR_GREY,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    display: 'flex',
    flexDirection: 'column',
  },
  fixedWidth: {
    width: '290px !important',
  },
  width: {
    width: '100%',
  },
  disableResize: {
    resize: 'none'
  },
  input: {
    margin: '5px 0 10px 0',
    color: GlobalStyles.color.COLOR_INPUT,
    WebkitTextFillColor: GlobalStyles.color.COLOR_INPUT,
    backgroundColor: '#F4F8FA',
    '&::placeholder': {
      color: GlobalStyles.color.COLOR_GREY,
      fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
      fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    },
    '&:focus': {
      color: '#708090',
    },
  },
  inputContainer: {
    position: 'relative',
  },
  resetButton: {
    position: 'absolute',
    top: '25%',
    right: 10,
    borderWidth: 0,
    borderColor: 'none',
    background: 'none',

    '&:focus': {
      outlineStyle: 'none',
    },
  },
  resetButtonImage: {
    height: 15,
    width: 15,
  }
});

export default styles;
